import { SIZES, LINE_TYPES } from '../firebase/schema';
import { mapDbTypeToLineType } from './customerDesignLibrary';

export const DOCUMENT_LINE_TYPE_ORDER = [
  LINE_TYPES.SCREEN_PRINT,
  LINE_TYPES.DTF,
  LINE_TYPES.EMBROIDERY,
  LINE_TYPES.DTG,
  LINE_TYPES.DESIGN_ONLY
];

export const SIZE_TYPE_ORDER = ['ADULT', 'ADULT_EXTENDED', 'YOUTH', 'TODDLER', 'INFANT', 'ONESIZE'];

export const getSizeTypeForLine = (line) => {
  if (!line?.sizes) return 'ADULT';

  const lineSizes = Object.keys(line.sizes).filter((s) => line.sizes[s] > 0);

  if (line.sizeType) {
    const normalizedType = String(line.sizeType).toUpperCase().replace(/\s+/g, '_');
    if (SIZES[normalizedType]) return normalizedType;
  }

  for (const [sizeType, sizes] of Object.entries(SIZES)) {
    if (lineSizes.some((s) => sizes.includes(s))) {
      return sizeType;
    }
  }

  return 'ADULT';
};

/**
 * Group document lines by decoration type, then by size grid.
 */
export const groupDocumentLinesByType = (items = []) => {
  const byType = {};

  items.forEach((line) => {
    const lineType = mapDbTypeToLineType(line.type);
    const sizeType = getSizeTypeForLine(line);
    if (!byType[lineType]) byType[lineType] = {};
    if (!byType[lineType][sizeType]) byType[lineType][sizeType] = [];
    byType[lineType][sizeType].push(line);
  });

  const orderedTypes = [
    ...DOCUMENT_LINE_TYPE_ORDER.filter((type) => byType[type]),
    ...Object.keys(byType).filter((type) => !DOCUMENT_LINE_TYPE_ORDER.includes(type))
  ];

  return orderedTypes.map((lineType) => ({
    lineType,
    sizeGroups: SIZE_TYPE_ORDER
      .filter((sizeType) => byType[lineType][sizeType]?.length)
      .map((sizeType) => ({
        sizeType,
        lines: byType[lineType][sizeType]
      }))
  }));
};
